module.exports = __webpack_public_path__ + "static/media/atca.8a856515.png";